module.exports = __webpack_public_path__ + "ipad-spacegray@2x.png?7e514f4fdc2f5310345a3fea37f65fda";